export default [
    {
        path: '/luggagerule', // 行李规则
        component: resolve => require(['@/pages/inforule/luggagerule'], resolve),
        meta: { title: "长龙航空" }
    },
    { 	
    	path: '/luggagerefundrule', // 预付费行李退改签规则
        component: resolve => require(['@/pages/inforule/luggagerefundRule'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/web/travel/dangerRule', // 危险品
        component: resolve => require(['@/pages/inforule/dangerRule'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/vipRule', // 会员俱乐部条款
        component: resolve => require(['@/pages/inforule/vipRule'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/privacy', // 隐私条款
        component: resolve => require(['@/pages/inforule/privacy'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/scheduled', // 航机媒体
        component: resolve => require(['@/pages/inforule/scheduled'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/flightIntro', // 航班介绍
        component: resolve => require(['@/pages/inforule/flightIntro'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/vipHandbook', // 会员手册
        component: resolve => require(['@/pages/inforule/vipHandbook'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/handbookDetail', // 会员手册具体内容
        component: resolve => require(['@/pages/inforule/handbookDetail'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/msgtip', // 出票短信提示
        component: resolve => require(['@/pages/inforule/msgtip'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/BuyluggageRules', // 预付费行李购买须知
        component: resolve => require(['@/pages/inforule/buyLuggageRules'], resolve),
        meta: { title: "长龙航空" }
    },  
    {
        path: '/publicInforule', // 公用文章
        component: resolve => require(['@/pages/inforule/public'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/userAgree', // 用户会员协议
        component: resolve => require(['@/pages/inforule/userAgree'], resolve),
        meta: { title: "长龙航空" }
    },
]



// WEBPACK FOOTER //
// ./src/router/modules/inforule.js